import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCheckmark2"><Path d="M2.5 15.5L9.20588 20.5L21.5 3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCheckmark2;
